export function reportRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "FETCH_CLIENT_REPORTS_START":           
        case "FETCH_REPORTS_START":           
            return {
                ...state, 
                fetching:true
            }        
        case "FETCH_CLIENT_REPORTS_FULFILLED":           
        case "FETCH_REPORTS_FULFILLED":           
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "FETCH_CLIENT_REPORTS_ERROR":
        case "FETCH_REPORTS_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}